import { IonCol, IonItem, IonLabel, IonList, IonRow, IonToggle } from '@ionic/react'
import React, { BaseSyntheticEvent } from 'react'
import SingleSelect from '../../../../../components/singleSelect/SingleSelect.component'
import SInput from '../../../../../components/stringInput/StringInput.component'
import { useTranslation } from 'react-i18next'
import { IDrainsAndTubesState } from '../store/drainsAndTubes.types'
import { useDispatch, useSelector } from 'react-redux'
import { getDrainsAndTubesSelector } from '../selectors'
import {
  setChestTubeL,
  setChestTubeLSuction,
  setChestTubeR,
  setChestTubeRSuction,
  setColostomy,
  setCsfColor,
  setFoley,
  setFoleyColor,
  setIleostomy,
  setNgTube,
  setNgTubeSuction,
  setOgTube,
  setOgTubeSuction,
  setPegTube,
  setPegTubeCapped,
  setVentriculostomy,
} from '../store/drainsAndTubes.actions'
import { IOption } from '../../../../../common/common.types'
import { getDrainOptionsSelector } from '../../../../options/selectors'
import Validation from '../../../../../components/validation/Validation.component'
import { DrainsAndTubesConstants } from '../store/drainsAndTubes.constants'

const DrainsTubesContent: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const drainsAndTubesOptions = useSelector(getDrainOptionsSelector)
  const { chestSuctionOptions, csfColorOptions, drainSuctionOptions, foleyColorOptions, ileostomyColostomyOptions } =
    drainsAndTubesOptions
  const drainsAndTubesState: IDrainsAndTubesState = useSelector(getDrainsAndTubesSelector)
  const {
    ngTube,
    ngTubeSuction,
    ogTube,
    ogTubeSuction,
    chestTubeL,
    chestTubeLSuction,
    chestTubeR,
    chestTubeRSuction,
    foley,
    foleyColor,
    pegTube,
    pegTubeCapped,
    ileostomy,
    colostomy,
    ventriculostomy,
    csfColor,
    // comments,
  } = drainsAndTubesState

  const setNGTubeOnChange = (e: CustomEvent) => {
    dispatch(setNgTube(e.detail.value))
  }

  const setNGTubeSuctionOnChange = (option: IOption) => {
    dispatch(setNgTubeSuction(option))
  }

  const setOGTubeOnChange = (e: CustomEvent) => {
    dispatch(setOgTube(e.detail.value))
  }

  const setOGTubeSuctionOnChange = (option: IOption) => {
    dispatch(setOgTubeSuction(option))
  }

  const setChestTubeLOnChange = (e: CustomEvent) => {
    dispatch(setChestTubeL(e.detail.value))
  }

  const setChestTubeLSuctionOnChange = (option: IOption) => {
    dispatch(setChestTubeLSuction(option))
  }

  const setChestTubeROnChange = (e: CustomEvent) => {
    dispatch(setChestTubeR(e.detail.value))
  }

  const setChestTubeRSuctionOnChange = (option: IOption) => {
    dispatch(setChestTubeRSuction(option))
  }

  const setFoleyOnChange = (e: CustomEvent) => {
    dispatch(setFoley(e.detail.value))
  }

  const setFoleyColorOnChange = (option: IOption) => {
    dispatch(setFoleyColor(option))
  }

  const setPEGTubeOnChange = (e: CustomEvent) => {
    dispatch(setPegTube(e.detail.value))
  }

  const setIleostomyOnChange = (option: IOption) => {
    dispatch(setIleostomy(option))
  }

  const setColostomyOnChange = (option: IOption) => {
    dispatch(setColostomy(option))
  }

  const setVentriculostomyOnChange = (e: CustomEvent) => {
    dispatch(setVentriculostomy(e.detail.value))
  }

  const setCSFColorOnChange = (option: IOption) => {
    dispatch(setCsfColor(option))
  }

  const onToggleAction = (e: BaseSyntheticEvent) => {
    dispatch(setPegTubeCapped(e.target.checked))
  }

  return (
    <>
      <IonList className='overflow-y-auto'>
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.NGTube')}
              dataTestID='NGTube'
              inputValue={ngTube}
              onChangeAction={setNGTubeOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_NG_TUBE} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='NGTubeSuction'
              options={drainSuctionOptions}
              selectedOption={ngTubeSuction}
              listHeader={t('drainsAndTubes.NGTubeSuction')}
              label={t('drainsAndTubes.NGTubeSuction')}
              action={setNGTubeSuctionOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.OGTube')}
              dataTestID='OGTube'
              inputValue={ogTube}
              onChangeAction={setOGTubeOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_OG_TUBE} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='OGTubeSuction'
              options={drainSuctionOptions}
              selectedOption={ogTubeSuction}
              listHeader={t('drainsAndTubes.OGTubeSuction')}
              label={t('drainsAndTubes.OGTubeSuction')}
              action={setOGTubeSuctionOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.ChestTubeL')}
              dataTestID='ChestTubeL'
              inputValue={chestTubeL}
              onChangeAction={setChestTubeLOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_CHEST_TUBE_L} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='ChestTubeLSuction'
              options={chestSuctionOptions}
              selectedOption={chestTubeLSuction}
              listHeader={t('drainsAndTubes.ChestTubeLSuction')}
              label={t('drainsAndTubes.ChestTubeLSuction')}
              action={setChestTubeLSuctionOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.ChestTubeR')}
              dataTestID='ChestTubeR'
              inputValue={chestTubeR}
              onChangeAction={setChestTubeROnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_CHEST_TUBE_R} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='ChestTubeRSuction'
              options={chestSuctionOptions}
              selectedOption={chestTubeRSuction}
              listHeader={t('drainsAndTubes.ChestTubeRSuction')}
              label={t('drainsAndTubes.ChestTubeRSuction')}
              action={setChestTubeRSuctionOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.Foley')}
              dataTestID='Foley'
              inputValue={foley}
              onChangeAction={setFoleyOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_FOLEY} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='FoleyColor'
              options={foleyColorOptions}
              selectedOption={foleyColor}
              listHeader={t('drainsAndTubes.FoleyColor')}
              label={t('drainsAndTubes.FoleyColor')}
              action={setFoleyColorOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.PEGTube')}
              dataTestID='PEGTube'
              inputValue={pegTube}
              onChangeAction={setPEGTubeOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_PEG_TUBE} />
          </IonCol>
          <IonCol className='picklist'>
            <IonItem lines='none'>
              <IonLabel>
                <div className='toggle-button'>
                  <span>{t('drainsAndTubes.PEGTubeCapped')}</span>
                </div>
              </IonLabel>
              <IonToggle
                slot='start'
                name='PEGTubeCapped'
                color='zoll-blue-secondary'
                checked={Boolean(pegTubeCapped)}
                onClick={onToggleAction}
              />
            </IonItem>
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Ileostomy'
              options={ileostomyColostomyOptions}
              selectedOption={ileostomy}
              listHeader={t('drainsAndTubes.Ileostomy')}
              label={t('drainsAndTubes.Ileostomy')}
              action={setIleostomyOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='Colostomy'
              options={ileostomyColostomyOptions}
              selectedOption={colostomy}
              listHeader={t('drainsAndTubes.Colostomy')}
              label={t('drainsAndTubes.Colostomy')}
              action={setColostomyOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
        <IonRow>
          <IonCol className='picklist'>
            <SInput
              label={t('drainsAndTubes.Ventriculostomy')}
              dataTestID='Ventriculostomy'
              inputValue={ventriculostomy}
              onChangeAction={setVentriculostomyOnChange}
            />
            <Validation id={DrainsAndTubesConstants.SET_VENTRICULOSTOMY} />
          </IonCol>
          <IonCol className='picklist'>
            <SingleSelect
              dataTestID='CSFColor'
              options={csfColorOptions}
              selectedOption={csfColor}
              listHeader={t('drainsAndTubes.CSFColor')}
              label={t('drainsAndTubes.CSFColor')}
              action={setCSFColorOnChange}
            />
          </IonCol>
        </IonRow>
        <hr className='field-divider' />
      </IonList>
    </>
  )
}
export default DrainsTubesContent
